import { getFetchedDataPayload, isFetchedDataValid, LoadingState, logger } from '@vista/omnichannel-components-domain';
import { useCallback, useEffect, useState } from 'react';
export const getInitialLoadingState = (data) => {
    return data ? LoadingState.Success : LoadingState.Loading;
};
export const useLoadActionForData = (loadAction, fetchedData) => {
    const [loadingState, setLoadingState] = useState(() => getInitialLoadingState(fetchedData));
    const loadCallback = useCallback(() => {
        (async () => {
            try {
                setLoadingState(LoadingState.Loading);
                await loadAction();
                setLoadingState(LoadingState.Success);
            }
            catch (error) {
                setLoadingState(LoadingState.Failure);
            }
        })();
    }, [loadAction]);
    useEffect(loadCallback, [loadCallback]);
    // Check if the data is expired every time the component is rendered in case it needs to reload.
    const isDataExpired = loadingState === LoadingState.Success && !isFetchedDataValid(fetchedData);
    if (isDataExpired) {
        logger.info('Data expired. Reloading');
        loadCallback();
        return { loadingState: LoadingState.Loading, reload: loadCallback, data: undefined };
    }
    return { loadingState, reload: loadCallback, data: getFetchedDataPayload(fetchedData) };
};
